import React, { useState } from 'react';
import { Card, CardHeader, CardContent, CardActions, Divider, Grid, Button, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import api from '~/services/api';
import history from '~/services/history';
import { Container } from './styles';

export default function BranchNew() {
  const [itemInfo, setItemInfo] = useState({});
  const countries = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Côte dIvoire',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo (Congo-Brazzaville)',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czechia (Czech Republic)',
    'Democratic Republic of the Congo',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini (fmr. "Swaziland")',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Holy See',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar (formerly Burma)',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Korea',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine State',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Korea',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States of America',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ];

  async function handleSubmit() {
    await api.post('branches', itemInfo);
    history.push('/branches');
  }

  return (
    <Container>
      <Card>
        <form autoComplete="off" noValidate>
          <CardHeader subheader="" title="New Branch" />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={12} xs={12}>
                <TextField id="name" label="Name" onChange={e => setItemInfo({ ...itemInfo, name: e.target.value })} fullWidth required />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField name="address1" label="Address" onChange={e => setItemInfo({ ...itemInfo, address1: e.target.value })} fullWidth />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField name="city" label="City" onChange={e => setItemInfo({ ...itemInfo, city: e.target.value })} fullWidth />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField id="state" label="State" onChange={e => setItemInfo({ ...itemInfo, state: e.target.value })} fullWidth required />
              </Grid>
              <Grid item md={3} xs={12}>
                <Autocomplete
                  id="country"
                  options={countries}
                  getOptionLabel={option => option || ''}
                  style={{ width: '100%' }}
                  defaultValue=""
                  onChange={(e, newValue) => {
                    setItemInfo({ ...itemInfo, country: newValue.value });
                  }}
                  renderInput={params => <TextField {...params} label="Country" margin="normal" fullWidth />}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField id="zip_code" label="Postal Code" onChange={e => setItemInfo({ ...itemInfo, zip_code: e.target.value })} fullWidth required />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions onClick={handleSubmit}>
            <Button color="primary" variant="contained">
              Add Branch
            </Button>
          </CardActions>
        </form>
      </Card>
    </Container>
  );
}
